// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleMeta_root__2Ns8v","ideasRoot":"ArticleMeta_ideasRoot__1OuBR"};